"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapNumericFilter = mapNumericFilter;
function mapNumericFilter(filter) {
    if (filter.type !== 'NUMBER') {
        throw new Error(`Filter type ${filter.type} is not a number, cannot map to number`);
    }
    // For IS_BETWEEN, value should be an object with gte and lte
    if (filter.operator === 'IS_BETWEEN') {
        if (typeof filter.value !== 'object' || !('gte' in filter.value) || !('lte' in filter.value)) {
            throw new Error('IS_BETWEEN operator requires value to be an object with gte and lte properties');
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    else if (typeof filter.value !== 'number') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        throw new Error(`Filter value for operator ${filter.operator} must be a number`);
    }
    switch (filter.operator) {
        case 'IS_EQUAL_TO':
            return {
                term: {
                    [filter.field]: filter.value,
                },
            };
        case 'IS_NOT_EQUAL_TO':
            return {
                bool: {
                    must_not: {
                        term: {
                            [filter.field]: filter.value,
                        },
                    },
                },
            };
        case 'IS_GREATER_THAN':
            return {
                range: {
                    [filter.field]: {
                        gt: filter.value,
                    },
                },
            };
        case 'IS_GREATER_THAN_OR_EQUAL_TO':
            return {
                range: {
                    [filter.field]: {
                        gte: filter.value,
                    },
                },
            };
        case 'IS_LESS_THAN':
            return {
                range: {
                    [filter.field]: {
                        lt: filter.value,
                    },
                },
            };
        case 'IS_LESS_THAN_OR_EQUAL_TO':
            return {
                range: {
                    [filter.field]: {
                        lte: filter.value,
                    },
                },
            };
        case 'IS_BETWEEN':
            return {
                range: {
                    [filter.field]: {
                        gte: filter.value.gte,
                        lte: filter.value.lte,
                    },
                },
            };
        default:
            // @ts-expect-error -- ts is right this SHOULD be impossible if it's not you've added a new operator
            throw new Error(`Operator ${filter.operator} not implemented`);
    }
}
//# sourceMappingURL=map-numeric-filter.js.map